"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var Menu = function Menu(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.36 0H4.64001C2.77334 0 1.26001 1.51333 1.26001 3.38V16.62C1.26001 18.4867 2.77334 20 4.64001 20H15.36C15.3658 20 15.3733 20 15.38 20C17.2467 20 18.76 18.4867 18.76 16.62V3.38C18.76 1.51333 17.2467 0 15.38 0C15.3733 0 15.3658 0 15.3592 0H15.36V0ZM17.08 16.62C17.08 17.57 16.31 18.34 15.36 18.34H4.64001C3.69001 18.34 2.92001 17.57 2.92001 16.62V3.38C2.92001 2.43 3.69001 1.66 4.64001 1.66H15.36C16.31 1.66 17.08 2.43 17.08 3.38V16.62ZM14.16 5H5.84001C5.43501 5.065 5.12918 5.41167 5.12918 5.83C5.12918 6.24833 5.43501 6.595 5.83501 6.65917L5.84001 6.66H14.16C14.565 6.595 14.8708 6.24833 14.8708 5.83C14.8708 5.41167 14.565 5.065 14.165 5.00083L14.16 5ZM14.16 9.16H5.84001C5.37584 9.16 5.00001 9.53583 5.00001 10C5.00001 10.4642 5.37584 10.84 5.84001 10.84H14.16C14.6242 10.84 15 10.4642 15 10C15 9.53583 14.6242 9.16 14.16 9.16ZM10.84 13.34H5.84001C5.43501 13.405 5.12918 13.7517 5.12918 14.17C5.12918 14.5883 5.43501 14.935 5.83501 14.9992L5.84001 15H10.84C11.245 14.935 11.5508 14.5883 11.5508 14.17C11.5508 13.7517 11.245 13.405 10.845 13.3408L10.84 13.34Z"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "20",
    height: "20"
  }))));
};
var _default = exports["default"] = Menu;